import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import Markdown from '../../components/Markdown';
import Placeholder from '../../components/Placeholder';
import media from '../../styles/media.style';
import { SCREEN_LOCKUP_WIDTH, MOBILE_PADDING } from '../../styles/variables.style';

const Section = styled.section`
  margin: 0 auto;
  max-width: ${SCREEN_LOCKUP_WIDTH}px;
  padding: 40px ${MOBILE_PADDING}px;
  width: 100%;

  ${media.tabletL`
    display: flex;
    justify-content: space-between;
    padding: 80px ${MOBILE_PADDING * 4}px;;
  `};
`;

const Title = styled.div`
  font-size: 34px;
  text-align: center;

  ${media.tabletL`
    font-size: 44px;
    text-align: left;
    width: 45%;
  `};
`;

const Description = styled.div`
  margin-top: 20px;
  text-align: center;

  ${media.tabletL`
    margin-top: 0;
    text-align: left;
    width: 45%;
  `};

  p {
    font-size: 16px;

    &:first-child {
      margin-top: 0;
    }
  }
`;

const OverviewSection = ({ title, description }) => (
  <Section>
    <Title>{title || <Placeholder w="60%" pb="20%" />}</Title>
    {description ? (
      <Markdown src={description} Component={Description} />
    ) : (
      <Description>
        <Placeholder w="100%" pb="40%" />
      </Description>
    )}
  </Section>
);

OverviewSection.defaultProps = {
  title: undefined,
  description: undefined,
};

OverviewSection.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
};

export default OverviewSection;



// WEBPACK FOOTER //
// ./src/pages/OurAssetsPage/OverviewSection.js